import Typography from '@components/common/typography';
import styles from './styles.module.scss';
import useModalContext from '@hooks/context/useModalContext';
import { useTranslation } from 'react-i18next';
import { prettifyStars } from '@utils/index';
import InfoBlock from '@components/common/info_block';

const CreateApiKeyWarnModal = () => {
    const { t } = useTranslation('modals', {
        keyPrefix: 'delete_account'
    });

    return (
        <div className={styles.wrapper}>
            <Typography className={styles.title} variant="h4">
                Create new API key
            </Typography>
            <Typography variant="body2" alignment="center">
                Are you sure you want to create a new API key? Your current key will be permanently
                deleted.
            </Typography>
            <InfoBlock variant="warning">
                Please note: Deleting the current key will immediately revoke access. Any API
                requests made using it will be rejected, and all webhooks associated with this key
                will be deleted, which could cause systems still relying on them to stop working.
            </InfoBlock>
        </div>
    );
};

export default CreateApiKeyWarnModal;
